import type { ProLayoutProps } from "@ant-design/pro-components";

/**
 * 阿里云控制台风格配置
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  splitMenus: false,
  // 导航主题：light 表示浅色导航栏
  navTheme: "light",
  // 主色调：阿里云蓝 #0064C8
  colorPrimary: "#0064C8",
  // 布局方式：side 表示侧边导航
  layout: "side",
  // 内容区域宽度：Fluid 表示流式布局
  contentWidth: "Fluid",
  // 固定头部
  fixedHeader: true,
  // 固定侧边栏
  fixSiderbar: true,
  // 色弱模式
  colorWeak: false,
  siderMenuType: "group",
  // 系统名称
  title: "洋柿子管理平台",
  // PWA 支持
  pwa: true,
  // Logo
  logo: "/logo.png",
  // 图标字体
  iconfontUrl: "",
  // 主题 Token 配置（阿里云控制台风格）
  token: {
    // 侧边栏配置
    sider: {
      colorMenuBackground: "#FFFFFF",
      colorMenuItemBackground: "#FFFFFF",
      colorMenuItemText: "#1F2329",
      colorMenuItemTextHover: "#0064C8",
      colorMenuItemSelectedBackground: "#E5F0FF",
      colorMenuItemSelectedText: "#0064C8",
    },
    // 头部配置
    header: {
      colorBgHeader: "#FFFFFF",
      colorHeaderTitle: "#1F2329",
      colorTextLight: "#1F2329",
    },
  },
};

export default Settings;
